import { cn } from "../../../../utils/cn";
import styles from "./MapCtaButtons.module.scss";

type Props = {
  primaryLabel: string;
  onPrimary: () => void;
  primaryTestId: string;
  primaryDisabled?: boolean;
  // Skip is optional — when omitted the primary button spans the full width.
  skipLabel?: string;
  onSkip?: () => void;
  skipTestId?: string;
};

/**
 * Shared sticky-footer CTA row used across every order type's location screen
 * (delivery map + branch list). One component so the Skip / primary buttons look
 * identical everywhere — matches the Figma "Sticky buttons" spec.
 */
export const MapCtaButtons = ({
  primaryLabel,
  onPrimary,
  primaryTestId,
  primaryDisabled = false,
  skipLabel,
  onSkip,
  skipTestId,
}: Props) => {
  const showSkip = Boolean(onSkip && skipLabel);

  return (
    <div className={styles.cta_row}>
      {showSkip && (
        <button
          type="button"
          className={styles.btn_skip}
          onClick={onSkip}
          data-testid={skipTestId}
        >
          {skipLabel}
        </button>
      )}
      <button
        type="button"
        className={cn(styles.btn_primary, !showSkip && styles.btn_primary_full)}
        onClick={onPrimary}
        disabled={primaryDisabled}
        data-testid={primaryTestId}
      >
        {primaryLabel}
      </button>
    </div>
  );
};
